var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1273",
    "data-name": "Group 1273",
    transform: "translate(-6029 -2907)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    d: "M6037.985,2916.183v3.634a.868.868,0,0,0,.813.913.749.749,0,0,0,.4-.12l3.242-1.817a.977.977,0,0,0,.3-1.246.887.887,0,0,0-.3-.34l-3.242-1.816a.767.767,0,0,0-1.109.34,1,1,0,0,0-.107.452Zm7.664,10.075h-11.3a2.613,2.613,0,0,1-2.61-2.61v-11.3a2.613,2.613,0,0,1,2.61-2.61h11.3a2.613,2.613,0,0,1,2.609,2.61v11.3A2.613,2.613,0,0,1,6045.649,2926.258Zm-11.3-15.328a1.424,1.424,0,0,0-1.423,1.422v11.3a1.424,1.424,0,0,0,1.423,1.422h11.3a1.423,1.423,0,0,0,1.422-1.422v-11.3a1.423,1.423,0,0,0-1.422-1.422Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_549",
    "data-name": "Rectangle 549",
    width: 22,
    height: 22,
    transform: "translate(6029 2907)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideo);
export default __webpack_public_path__ + "static/media/icon-video.94b00b15892aa61b13d3587c10fa9273.svg";
export { ForwardRef as ReactComponent };